import Extension from "../base/extension";

/**
 * Delegated behaviours for native details/summary disclosure widgets
 * (accordion-item snippet: accordion section, footer menu accordions,
 * metaobject accordions). Exclusive open needs no JS at all: the drawers
 * share a details[name] group. This extension only covers the theme
 * editor: selecting a drawer block in the sidebar opens its details so
 * the merchant sees what they are editing (the disclosure equivalent of
 * what utility-customizer does for offcanvas/modal and Tabs does for
 * tab panes).
 */
class Disclosures extends Extension {
  name = "Disclosures";

  constructor(name) {
    super(name);
  }

  init() {
    // In-page anchors targeting (or landing inside) a details element open it
    // before the browser scrolls: "Read more" links to a product drawer, and
    // any future deep link into a disclosure.
    document.addEventListener("click", (event) => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || anchor.getAttribute("href").length < 2) return;
      this.openDetailsFor(anchor.getAttribute("href"));
    });

    if (window.location.hash) {
      this.openDetailsFor(window.location.hash);
    }

    // Minimal collapse replacement for simple show/hide regions (facets
    // sidebar mobile toggle, gift-card recipient fields): buttons and
    // checkboxes carrying data-disclosure-target toggle the target's hidden
    // attribute and mirror aria-expanded. Display utilities like d-lg-block
    // (!important) deliberately beat the hidden attribute, which is how the
    // facets sidebar stays open at desktop.
    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("button[data-disclosure-target]");
      if (!trigger) return;
      const target = document.querySelector(trigger.dataset.disclosureTarget);
      if (!target) return;
      target.hidden = !target.hidden;
      trigger.setAttribute("aria-expanded", String(!target.hidden));
    });

    document.addEventListener("change", (event) => {
      const box = event.target.closest('input[type="checkbox"][data-disclosure-target]');
      if (!box) return;
      const target = document.querySelector(box.dataset.disclosureTarget);
      if (!target) return;
      target.hidden = !box.checked;
      box.setAttribute("aria-expanded", String(box.checked));
    });

    // Popovers (header search): focus the first input on open so keyboard
    // users land in the search field. toggle events do not bubble: capture.
    document.addEventListener("toggle", (event) => {
      if (!event.target.matches?.("[popover]")) return;
      if (event.newState === "open") {
        event.target.querySelector("input, [autofocus]")?.focus();
      }
    }, true);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener("shopify:block:select", (event) => {
        const details = event.target.closest("details") || event.target.querySelector("details");
        if (details) details.open = true;
      });
    }
  }

  openDetailsFor(hash) {
    let target;
    try {
      target = document.querySelector(hash);
    } catch (e) {
      return; // not a valid selector (e.g. templated href)
    }
    if (!target) return;
    const details = target.tagName === "DETAILS" ? target : target.closest("details");
    if (details) details.open = true;
  }
}

export default Disclosures;
